import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {Modal, ModalBody, ModalFooter} from "react-bootstrap";
import {request} from "../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../helper/helper";
import {contractRateTypeEnum, serviceTypeEnum} from "../helper/enums";
import MaskedInput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";
import {validateComponent, validateField} from "../common/validation";
import Alert from "react-s-alert";
import moment from "moment";
import YoutubePlayer from "react-youtube-player";

class EdefterApplicationModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			customerLoading: false,
			customer: null,
			error: {},
			sorumluFieldsValid: false,
		};

		this.doEdefterApplication = this.doEdefterApplication.bind(this);
		this.getCustomer = this.getCustomer.bind(this);
		this.prepareCustomer = this.prepareCustomer.bind(this);
		this.renderApplicationBody = this.renderApplicationBody.bind(this);
		this.renderGetInfoBody =  this.renderGetInfoBody.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.saveCustomer = this.saveCustomer.bind(this);
		this.checkContactPersonInfo = this.checkContactPersonInfo.bind(this);
		this.onChangeCustomer = this.onChangeCustomer.bind(this);
		this.validateField =this.validateField.bind(this);
		this.onChangeCustomer = this.onChangeCustomer.bind(this);
	}

	componentDidMount() {
		if(this.props.customer && !this.props.showBody){
			let customer = this.props.customer;
			let sorumluFieldsValid = !this.props.edefterApplicationModal;
			this.setState({ customer, sorumluFieldsValid});
		}else {
			this.getCustomer();
		}
	}

	getCustomer() {
		let self = this;
		let params = {
			url: '/customer/findByRecordId/' ,
			method: "post",
			data: self.props.currentUser.customerId,
		};

		if(!self.props.currentUser.customerId){
			return;
		}

		self.setState({ customerLoading: true,});
		request(params).then(function (response) {
			let customer = response.data;
			let sorumluFieldsValid = self.checkContactPersonInfo(customer);
			console.log("sorumluFieldsValid",sorumluFieldsValid);
			self.setState({ customer, customerLoading: false, sorumluFieldsValid});
		}).catch(function (error) {
			self.setState({customerLoading: false});
			showAxiosError(error);
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangeCustomer(e) {
		let self = this;
		let customer = deepCopyObject(self.state.customer);
		let target = e.target;
		let value = target.value;
		if(target.name === 'sorumluTckn'){
			value = value.replace(/\D/g,'');
		}
		customer[target.name] = value;
		self.setState({customer});
	}

	saveCustomer(){
		let self = this;
		const data = this.state.customer;
		let params = {
			url: `/customer/createCustomer`,
			data: data,
			method: 'post'
		};

		let validity = this.validateComponent();

		if(validity.valid){
			self.setState({ loading: true});
			request(params).then(function (response) {
				let sorumluFieldsValid = self.checkContactPersonInfo(self.state.customer);
				self.setState({loading: false, sorumluFieldsValid});
			}).catch(function (error) {
				self.setState({loading: false});
				showAxiosError(error);
			});
		}else{
			Alert.error("Hatalı ya da eksik alanlar var!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	doEdefterApplication() {
		let self = this;
		let customer = this.prepareCustomer();
		let params = {
            url: '/customer/createCustomer',
            method: "post",
			data: customer
        };

		self.setState({ loading: true });

		request(params).then(function (response) {
			self.setState({ loading: false });
            self.props.refresh();
        }).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	renderApplicationBody(){
		return (
			<Modal show={this.props.edefterApplicationModal} onHide={this.props.cancel} size='lg'>
				<Modal.Header closeButton style={{padding: '22px 25px'}}>e-Defter Başvurusu</Modal.Header>
				<Modal.Body>
					<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '80%'}}>
							<img src='image/defterlogo.png' style={{width:"30%"}} alt="logo"/>
							<p style={{
								fontSize: '16px',
								fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
								fontWeight: '400',
								marginBottom: '0',
								textAlign: 'center',
								lineHeight: '15px'
							}}>e-Defter başvurunuzu onayladığınızda, önce GİB e-Defter başvurusu imzalama sayfasına, ardından sözleşme imzalama sayfasına yönlendirileceksiniz.<br/>
								<b>Lütfen e-imzanızı yanınızda bulundurunuz.</b>
							</p>
						</div>
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: "350px"}}>
							<YoutubePlayer
								videoId="5bs8TFV3l54"
								playbackState='unstarted'
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<div>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
										padding: '10px 54px 10px 23px'
									}}
									rel="tooltip" className="TekBtn vazgec btn-icon"
									onClick={this.props.cancel}>
								İptal
							</button>
						</div>

						<div>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										padding: '10px 54px 10px 23px',
										float:'right'
									}}
									rel="tooltip" className="TekBtn kaydet btn-icon"
									disabled={this.state.loading || this.state.customerLoading}
									onClick={() => this.doEdefterApplication()}>Onayla
							</button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		)
	}

	renderGetInfoBody(){
		return(
			<Modal show={this.props.edefterApplicationModal} onHide= {this.props.close} size='lg' backdrop='static'>
				<Modal.Header closeButton={ this.props.currentUser.impersonate || this.props.cancellable } style={{padding: '22px 25px'}}>Sorumlu Bilgilerini Doldurunuz!</Modal.Header>
			<Modal.Body>
			<div className="col-sm-12">
				<div className="col-sm-8 row mx-auto">
					<div className="col-sm-4">
						<label>Sorumlu Tckn *</label>
					</div>
					<div className="col-sm-8">
						<div className={"form-group" + this.validateClass('tSorumluTckn')}>
							<input className="form-control"
								   disabled={this.state.loading}
								   maxLength='11'
								   type="text"
								   id="tSorumluTckn"
								   data-vlength="11"
								   onBlur={this.validateField}
								   ref="tSorumluTckn"
								   name="sorumluTckn"
								   value={this.state.customer ? this.state.customer.sorumluTckn : ""}
								   onChange={(e) => this.onChangeCustomer(e)}/>
							{this.validateMessage('tSorumluTckn') !== "" &&
							<UncontrolledTooltip placement="right" target="tSorumluTckn" delay={0}>
								{this.validateMessage("tSorumluTckn")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-sm-8 row mx-auto">
					<div className="col-sm-4">
						<label>Sorumlu Adı *</label>
					</div>
					<div className="col-sm-8" style={{maxWidth: "none"}}>
						<div className={"form-group" + this.validateClass('tSorumluAd')}>
							<input className="form-control"
								   disabled={this.state.loading}
								   type="text"
								   id="tSorumluAd"
								   data-vlength="1,45"
								   onBlur={this.validateField}
								   ref="tSorumluAd"
								   name="sorumluAd"
								   value={this.state.customer ? this.state.customer.sorumluAd : ""}
								   onChange={(e) => this.onChangeCustomer(e)}/>
							{this.validateMessage('tSorumluAd') !== "" &&
							<UncontrolledTooltip placement="right" target="tSorumluAd" delay={0}>
								{this.validateMessage("tSorumluAd")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-sm-8 row mx-auto">
					<div className="col-sm-4">
						<label>Sorumlu Soyadı *</label>
					</div>
					<div className="col-sm-8">
						<div className={"form-group" + this.validateClass('tSorumluSoyad')}>
							<input className="form-control"
								   disabled={this.state.loading}
								   type="text"
								   id="tSorumluSoyad"
								   data-vlength="1,45"
								   onBlur={this.validateField}
								   ref="tSorumluSoyad"
								   name="sorumluSoyad"
								   value={ this.state.customer ? this.state.customer.sorumluSoyad : ""}
								   onChange={(e) => this.onChangeCustomer(e)}/>
							{this.validateMessage('tSorumluSoyad') !== "" &&
							<UncontrolledTooltip placement="right" target="tSorumluSoyad" delay={0}>
								{this.validateMessage("tSorumluSoyad")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-sm-8 row mx-auto">
					<div className="col-sm-4">
						<label>Sorumlu Cep Tel. *</label>
					</div>
					<div className="col-sm-8" style={{maxWidth: "none"}}>
						<div className={"form-group" + this.validateClass('tSorumluCepTel')}>
							<MaskedInput className="form-control"
										 disabled={this.state.loading}
										 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
										 placeholder="+90__________"
										 type="text"
										 id="tSorumluCepTel"
										 ref="tSorumluCepTel"
										 inputProps={{vdata: "phone", vlength: '1,13'}}
										 onBlur={() => this.validateField({
											 target: {
												 id: "tSorumluCepTel",
												 dataset: {vdata: 'phone', vlength: '1,13'},
												 value: this.state.customer.sorumluCepTel
											 }
										 })}
										 name="sorumluCepTel"
										 value={this.state.customer ? this.state.customer.sorumluCepTel : ""}
										 onChange={(e) => this.onChangeCustomer(e)}/>
							{this.validateMessage('tSorumluCepTel') !== "" &&
							<UncontrolledTooltip placement="right" target="tSorumluCepTel" delay={0}>
								{this.validateMessage("tSorumluCepTel")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-sm-8 row mx-auto">
					<div className="col-sm-4">
						<label>Sorumlu e-Posta *</label>
					</div>
					<div className="col-sm-8">
						<div className={"form-group" + this.validateClass('tSorumluEPosta')}>
							<MaskedInput className="form-control"
										 disabled={this.state.loading}
										 mask={emailMask}
										 placeholder="_________@______.___"
										 type="text"
										 name="sorumluEPosta"
										 id="tSorumluEPosta"
										 onBlur={() => this.validateField({
											 target: {
												 id: "tSorumluEPosta",
												 dataset: {vdata: "email", vlength: '1,255'},
												 value: this.state.customer.sorumluEPosta
											 }
										 })}
										 inputProps={{vdata: "email", vlength: '1,255'}}
										 ref="tSorumluEPosta"
										 value={this.state.customer ? this.state.customer.sorumluEPosta :""}
										 onChange={(e) => this.onChangeCustomer(e)}/>
							{this.validateMessage('tSorumluEPosta') !== "" &&
							<UncontrolledTooltip placement="right" target="tSorumluEPosta" delay={0}>
								{this.validateMessage("tSorumluEPosta")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
			</div>
			</Modal.Body>
				<ModalFooter>

					<div className="col-sm-12 row mx-auto">
							<div className="col-sm-2 ">
								{(this.props.currentUser.impersonate || this.props.cancellable) &&
								< button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
									background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
									padding: '10px 54px 10px 23px',
								}}
									rel="tooltip" className='TekBtn vazgec btn-icon'
									onClick={this.props.cancel}
									disabled={this.state.loading}>
									İptal
									</button>
								}
							</div>
						<div className="col-sm-8 "></div>
						<div className="col-sm-2 ">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										padding: '10px 54px 10px 23px',
										float:'right'
									}}
									rel="tooltip" className="TekBtn kaydet btn-icon"
									disabled={this.state.loading || this.state.customerLoading}
									onClick={() => this.saveCustomer()}>Bilgileri Kaydet
							</button>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		)
	}

	renderLoadingText(){
		return (
			<Modal show={this.props.edefterApplicationModal}  size='lg'>
				<Modal.Header style={{padding: '22px 25px'}}>e-Defter Başvurusu</Modal.Header>
				<Modal.Body>
					<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
						<label>YÜKLENİYOR...</label>
					</div>
				</Modal.Body>
			</Modal>
		)
	}

	checkContactPersonInfo(customer){
		if(!customer){
			return false;
		}else if( (!customer.sorumluTckn || customer.sorumluTckn && customer.sorumluTckn === "") ||
			(!customer.sorumluAd || customer.sorumluAd && customer.sorumluAd === "") ||
			(!customer.sorumluSoyad || customer.sorumluSoyad && customer.sorumluSoyad === "") ||
			(!customer.sorumluCepTel || customer.sorumluCepTel && customer.sorumluCepTel === "") ||
			(!customer.sorumluEPosta || customer.sorumluEPosta && customer.sorumluEPosta === "")){
			return false;
		}else{
			return true;
		}
	}

	render() {
		return (
			<div>
				{
					this.state.customerLoading
						?
						this.renderLoadingText()
						:
						!this.state.sorumluFieldsValid
							?
							this.renderGetInfoBody()
							:
							this.props.showBody ? this.renderApplicationBody() : this.props.close()
				}
			</div>
		)
	}

	prepareCustomer() {
		let customer = this.state.customer;

		let customerContractServiceList = [{
			aliasList: [{workScopecode: null}],
			service: {recordId: serviceTypeEnum.E_DEFTER},
			terminated : false,
		}];

		if ([5925, 6951, 10941, 11611, 12359, 12359, 12584, 15829, 28839, 30735, 46486].includes(this.props.currentUser.parentCustomerId)) {
			customerContractServiceList.push({
				aliasList: [{workScopecode: null}],
				service: {recordId: serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA},
				terminated: false,
			});
		}

		let date = moment();
		let customerContract = {
			recordId : null,
			contractStartDate: date.format('YYYY-MM-DD'),
			contractFinishDate: date.add("year","1").format('YYYY-MM-DD'),
			rateType: (customer.customerContractList.length > 0 ? customer.customerContractList[0].rateType : contractRateTypeEnum.INVOICED),
			automaticExtension: false,
			customerContractServiceList: customerContractServiceList,
		};

		customer.customerContractList.push(customerContract);

		return customer;
	}
}

export default EdefterApplicationModal;